export default "__VITE_ASSET__6tJ$LBws__"